export interface TechBranch {
  id: string;
  label: string;
  nodes: string[];
}

// Kept deliberately short: the planet phase is a runway into the space game,
// so each branch is a single tight chain towards the Space Port / Rocket Program.
export const TECH_BRANCHES: TechBranch[] = [
  {
    id: 'observation',
    label: 'Observation',
    nodes: ['Study Parent Star', 'Telescope', 'Satellite', 'Orbital Telescope'],
  },
  {
    id: 'communication',
    label: 'Communication',
    nodes: ['Radio Tower', 'Signal Array'],
  },
  {
    id: 'propulsion',
    label: 'Propulsion',
    nodes: [
      'Launch Complex',
      'Space Port',
      'Rocket Program',
      'Orbital Dock',
      'Deep Space Probe',
    ],
  },
  {
    id: 'environment',
    label: 'Environment',
    nodes: ['Carbon Capture', 'Clean Energy'],
  },
];
